import classNames from 'classnames';
import styles from './LanguageSelector.module.scss';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import GreenlandishFlag from 'ui/icons/flag_kl-gl.svg';
import DanishFlag from 'ui/icons/flag_da.svg';
import EnglishFlag from 'ui/icons/flag_en.svg';

export interface LanguageLink {
	name: string;
	target?: string;
	url: string;
}

export interface LanguageSelectorProps {
	className?: string;
	links: LanguageLink[];
	currentLinkName: string;
}

export const UI_LanguageSelector = ({ className, links, currentLinkName }: LanguageSelectorProps) => {
	const flags = {
		'kl-gl': GreenlandishFlag,
		da: DanishFlag,
		en: EnglishFlag,
	};

	return (
		<ul className={classNames(styles.LanguageSelector, className)}>
			{links.map((link, index) => {
				const locale = link.url.split('/')[1]?.toLowerCase();
				const DynamicFlag = flags[locale];
				const isCurrentLanguage = link.name === currentLinkName;
				return (
					<li key={index}>
						<UI_LinkWithIcon
							className={classNames(styles.LanguageSelector_link, { [styles.LanguageSelector_link___active]: isCurrentLanguage })}
							url={link.url}
							target={link.target}
							locale={locale}
							icon={<DynamicFlag />}
							text={link.name}
							iconDropShadow
							iconAutoWidth
							reverseOrder
						/>
					</li>
				);
			})}
		</ul>
	);
};
